import React from 'react';

const NavMenuContext = React.createContext({
    isOpen: false,
    setIsOpen: () => {},
});

export default NavMenuContext